<template>
  <div>
    <Modal title = "Title" v-model = "showFormModal" class-name = "card-modal"
           :width = "action=='view'?400:900">
      <div slot = "header">
        <h4>{{title}}</h4>
      </div>
      <Form ref = "eventParticipantForm" :model = "eventParticipantForm" :rules = "ruleValidate"
            border shadow
            label-position = "top">
        <Row class = "widget-container">
          <i-col :xs = "24" :sm = "24" :md = "24" :lg = "24" style = "text-align: center;">
            <div class = 'full-input' style = "width: 50%">
              <label class = "label-answer" :for = "eventParticipantForm.eventName">
                <b><i>Event Name</i></b>
              </label>
              <FormItem label = "" :prop = "'eventName'"
                        :rules = "{required: true, message: 'Event Name cannot be empty', trigger: 'blur'}">
                <Label>{{eventParticipantForm.eventName}}</Label>
              </FormItem>
            </div>
          </i-col>
          <i-col :xs = "24" :sm = "24" :md = "24" :lg = "24" style = "text-align: center;">
            <div class = 'full-input' style = "width: 50%">
              <label class = "label-answer" :for = "eventParticipantForm.eventName">
                <b><i>Event Participants</i></b>
              </label>
              
              <div v-if="isAddingFile" class="d-flex justify-content-center align-items-center w-100">
                <div class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="mx-2">
                  Your file is loading...
                </div>
              </div>
              <FilePond
                :style="isAddingFile ? 'visibility:hidden !important;' : 'visibility:visible !important;'"
                ref="uploadFileInput"
                dropValidation="true"
                label-idle="Drop the participants Excel file here or <span class='filepond--label-action'>Browse</span>"
                accepted-file-types="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                @initfile="oninitfile"
                @addfile="onaddfile"
                @removefile="onremovefile"
              />
            </div>
          </i-col>
        </Row>
      </Form>
      <Spin size = "large" fix v-if = "spinShow"></Spin>
      <div slot = "footer" id = "dvFooter">
        <Button class="btn btn-outline-secondary btn-sm" @click = "handleReset(true); showFormModal=false;" style = "margin-left: 8px">
          Cancel
        </Button>
        <Button class="submit btn btn-success btn-sm" type = "success"
                @click="handleUpdate('eventParticipantForm', eventParticipantForm.eventId)"
                :disabled="!this.newParticipantForm">
          Save
        </Button>
      </div>
    </Modal>

    <Modal v-model = "eventConfirmDelete" title = "CONFIRMATION"
           ok-text = "Continue" class-name = "vertical-center-modal card-modal"
           :width = "480">
      <div class = "confirmation-body">
        <p>
          <Icon type = "md-help-circle" size = "24" color = "#f90" />
          <span>{{eventDeleteMessage}}</span></p>
      </div>
      <div slot = "footer">
        <Button class="btn btn-outline-secondary btn-sm" @click = "handleClose">Cancel</Button>
        <Button @click = "processUpdate(eventParticipantForm.eventId)"
                class="submit btn btn-success btn-sm">Proceed
        </Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  import {getEventById, updateEvent} from '../../services/Events.service'
  import {addParticipantList, getByEventId} from '../../services/Participants.service'
  import {bus} from '../../main'
  import XLSX from 'xlsx'
  import vueFilePond from 'vue-filepond';
  import 'filepond/dist/filepond.min.css';
  import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';

  export default {
    components: {
      FilePond: vueFilePond(FilePondPluginFileValidateType)
    },
    data() {
      return {
        isAddingFile: false,
        fileAction: '//jsonplaceholder.typicode.com/posts/',
        file: null,
        dragEvent: null,
        loadingStatus: false,
        participants: [],
        oldParticipants: [],
        mergedParticipants: [],
        index: 0,
        action: 'Add',
        title: 'ADD Event',
        showFormModal: false,
        oldParticipantForm: null,
        newParticipantForm: null,
        eventParticipantForm: {
          eventId: null,
          eventName: null,
          location: null,
          startDate: null,
          endDate: null,
          bannerUrl: null,
          iconUrl: null,
          participantForm: null,
          createdBy: null,
          createdDate: null,
          deleted: false,
          deletionDate: null,
          updatedBy: null,
          updatedDate: null,
          userIds: null,
          leadIds: null,
          formIds: null,
          licenseIds: null,
          participantIds: null,
          companyIds: null,
        },
        ruleValidate: {},
        spinShow: true,
        state: {},
        eventId: null,
        eventDeleteMessage: '',
        eventConfirmDelete: false,
      }
    },
    methods: {
      oninitfile(file) {
        this.isAddingFile = true;
      },
      onaddfile(error, file) {
        this.parseFile(file.file);
      },
      onremovefile(error, file) {
        this.handleReset(false);
      },
      openEventParticipantForm(title, action) {
        this.title = title;
        this.action = action;
        this.showFormModal = true;
        this.handleReset(true);
      },
      setFormValue(params, index) {
        let data = Object.assign({}, params);
        delete data['_index'];
        delete data['_rowKey'];
        this.eventParticipantForm = data;
        this.eventId = params.eventId;
      },
      handleUpdate(name, id) {
        const self = this;
        self.spinShow = true;
        if (self.newParticipantForm) {
          getEventById(id).then(evt => {
            //check matching with existing

            if (self.newParticipantForm !== evt.data.participantForm && evt.data.participantForm != '') {
              self.eventDeleteMessage =
                `un-match found between Lead Form and this Participant List.\n\n`;
              self.eventDeleteMessage += `If you proceed any existing Lead Form will be deleted first.`;
              self.eventConfirmDelete = true;
            } else {
              self.processUpdate(id);
            }
          });
        } 
        else {
          self.$Message.error('No files uploaded.');
          self.spinShow = false;
        }
      },
      processUpdate(id) {
        const dataObj = Object.assign({}, this.eventParticipantForm);
        dataObj['participantForm'] = this.newParticipantForm;

        updateEvent(id, dataObj).then(response => {
          this.$emit('updateEvent', id, dataObj);
          console.log('Event Successfully updated!');
          // deleteParticipantList(id).then(() => {
          //   this.$emit('deleteParticipantList', id);
          //   console.log('Participants successfully Deleted!');
          addParticipantList(this.participants).then(() => {
            this.$emit('addParticipantList', this.participants);
            this.showFormModal = false;
            this.spinShow = false;
            console.log('Participants successfully updated!');
            bus.$emit('reloadAdminData');
            this.eventConfirmDelete = false;
          }).catch(error => {
            console.log('Failed Adding Participants');
          });
          // }).catch(error => {
          //   console.log('Failed Deleting Participants');
          // });
        }).catch(error => {
          console.log('Failed Updating Event ' + error);
        });

      },
      handleClose() {
        this.eventConfirmDelete = false;
        this.spinShow = false;
      },
      handleReset(isResetEventParticipantForm) {
        if(isResetEventParticipantForm){
          this.$refs['eventParticipantForm'].resetFields();
          let self = this;
          Object.keys(this.eventParticipantForm).forEach(function (key, i) {
            self.eventParticipantForm[key] = '';
          });
        }

        this.$refs.uploadFileInput.removeFiles();
        this.participants = [];
        this.oldParticipants = [];
        this.newParticipantForm = null;
        this.oldParticipantForm = null;
        this.spinShow = false;
      },
      /** PARSING and DRAGDROP **/
      handleDrop(e) {
        e.stopPropagation();
        e.preventDefault();
        
        this.parseFile(e.dataTransfer.files[0]);
      },
      parseFile(file){
        const vm = this;

        vm.file = file;

        // vm.dragEvent = e;
        let reader = new FileReader();
        // let evt = vm.dragEvent;
        let results = null;
        let dataObj = Object.assign({}, vm.eventParticipantForm);

        let getHeaderRow = function (sheet) {
          let headers = [], range = XLSX.utils.decode_range(sheet['!ref']);
          let C, R = range.s.r; /* start in the first row */
          for (C = range.s.c; C <= range.e.c; ++C) { /* walk every column in the range */
            let cell = sheet[XLSX.utils.encode_cell({c: C, r: R})] /* find the cell in the first row */
            let hdr = "UNKNOWN " + C; // <-- replace with your desired default
            if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
            if (cell) {
              headers.push(hdr.replace(/\s+/g, ''));
            }
          }
          return headers;
        };
        let workbookToJson = function (workbook) {
          let result = {};
          workbook.SheetNames.forEach(function (sheetName) {
            let roa = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName]);
            if (roa.length > 0) {
              result[sheetName] = roa;
            }
          });
          return result;
        };

        let participants = [];
        reader.onload = function (evt) {
          let data = evt.target.result;
          let worksheet = null;
          let o = "", l = 0, w = 10240;
          for (; l < data.byteLength / w; ++l) {
            o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w, l * w + w)));
          }
          o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
          let fixedData = o;
          let workbook = XLSX.read(btoa(fixedData), {type: 'base64'});
          let firstSheetName = workbook.SheetNames[0];
          worksheet = workbook.Sheets[firstSheetName];
          results = JSON.parse(JSON.stringify(XLSX.utils.sheet_to_json(worksheet)));

          vm.state.headers = getHeaderRow(worksheet);
          vm.state.tickets = results;

          for (let i = 0; i < results.length; i++) {
            let barcode = null;
            let obj = [];
            Object.keys(results[i]).forEach(function (key, x) {
              if (x == 0) {
                barcode = results[i][key];
              }
              let row = {};
              row[key.replace(/\s+/g, '')] = results[i][key];
              obj.push(row);
            });
            participants.push({
              id: null,
              eventId: dataObj['eventId'],
              barcode: barcode,
              participantForm: JSON.stringify(obj),
            });
          }
          vm.newParticipantForm = JSON.stringify(vm.state.headers);
          vm.oldParticipantForm = vm.eventParticipantForm.participantForm;
          vm.participants = participants;

          let list;
          let json = JSON.parse(vm.newParticipantForm);
          if (vm.oldParticipantForm && vm.oldParticipantForm !== '') {
            let json1 = JSON.parse(vm.oldParticipantForm);
            json = json.concat(json1);
          }

          json = json.filter((val, index, item) => item.indexOf(val) === index);
          vm.newParticipantForm = JSON.stringify(json);

          // getByEventId(vm.eventId).then(a => {
          //   vm.oldParticipants = a.data.result;
          // });
          //
          // list = participants.concat(vm.oldParticipants);
          // list = vm.getUnique(list, 'barcode');
          // list.sort((a, b) => (a.barcode > b.barcode) ? 1 : ((b.barcode > a.barcode) ? -1 : 0));

          // console.log(vm.oldParticipants);
          // vm.participants = list;

          vm.isAddingFile = false;
        };
        reader.readAsArrayBuffer(vm.file);
      },
      handleDragover(e) {
        e.stopPropagation();
        e.preventDefault();
        e.dataTransfer.dropEffect = 'copy';
      },
      handleFileSuccess(e) {
        console.log(e);
      },
      handleFileFormatError(e) {
        console.log(e);
      },
      handleFileSuccess(e, val, list) {
        console.log(e);
        console.log(val);
        console.log(list);
      },
      handleFileFormatError(e) {
        console.log(e);
      },
      getUnique(arr, comp) {
        const unique = arr.map(e => e[comp])

        // store the keys of the unique objects
          .map((e, i, final) => final.indexOf(e) === i && i)

          // eliminate the dead keys & store unique objects
          .filter(e => arr[e]).map(e => arr[e]);

        return unique;
      }
    },
    computed: {
    }
  }
</script>

<style scoped>
  #drop {
    border: 2px dashed #bbb;
    -moz-border-radius: 5px;
    -webkit-border-radius: 5px;
    border-radius: 5px;
    padding: 25px;
    text-align: center;
    font: 20pt bold, "Vollkorn";
    color: #bbb;
  }

  .full-input {
    display: inline-block;
    width: 100%;
    padding: 3px;
    border: 1px solid #f8f8f9;
    border-radius: 4px;
    width: 100%;
  }

  .input-answer {
    display: block;
    width: 100%;
    outline: none;
    border: none;
    line-height: 1.2em;
    font-size: 14pt;
  }

  .label-answer {
    text-align: left;
    display: block;
    font-size: 1em;
    font-style: italic;
    color: #000;
    opacity: 0.5
  }

  #dvFooter {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/k_globalAdministration/eventParticipantForm.vue